import { formatPhoneNumber } from "@/lib/formatters";
import { cn } from "@/lib/utils";
import type { Location } from "@curai/js-fhir-tools";
import { BodyText } from "../ui";

export function PharmacyOption({
  pharmacy,
  checked,
  onChange,
}: {
  pharmacy: Location;
  checked: boolean;
  onChange(): void;
}) {
  const { name, address, telecom, id } = pharmacy;

  return (
    <label
      htmlFor={`pharmacy-${id}`}
      className="bg-secondary p-3 rounded-lg flex flex-row gap-2"
    >
      <div>
        <input
          type="radio"
          id={`pharmacy-${id}`}
          name="pharmacy"
          value={id}
          className="peer hidden"
          onChange={onChange}
          checked={checked}
        />
        <div className="h-4 w-4 flex justify-center items-center rounded-full border bg-white">
          <span
            className={cn(
              "w-2 h-2 rounded-full block",
              checked && "bg-button-primary",
            )}
          />
        </div>
      </div>
      <div className="flex flex-col">
        <BodyText size="sm" textColor="success" bold>
          {name}
        </BodyText>

        {address?.line?.map((line) => (
          <BodyText key={line} size="sm">
            {line}
          </BodyText>
        ))}
        <BodyText size="sm">
          {address?.city}, {address?.state} {address?.postalCode}
        </BodyText>
        <BodyText size="sm">{formatPhoneNumber(telecom?.[0].value)}</BodyText>
      </div>
    </label>
  );
}
